<template>
    <Breadcrumbs main="Bonus Ui" title="Image Cropper" />
    <div class="container-fluid">
        <div class="img-cropper">
            <imageCropper />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const imageCropper = defineAsyncComponent(() => import("@/components/theme/advance/cropper/imageCropper.vue"))
</script>